import React, { Component } from 'react';
import {
  Button, Container, Form, Header, Icon,
  Message, Modal, Loader, Segment
} from 'semantic-ui-react';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import moment from 'moment';
import ReactTable from 'react-table';
import XLSX from 'xlsx';
import { snakeCase } from 'lodash';

const INITIAL_STATE = {
  libros: {
    loading: false,
    records: [],
    error: null
  },
  upsertModal: {
    open: false,
    loading: false,
    values: {
      id: null,
      concepto: 'ACTAS ASAMBLEA',
      nro: 1,
      fecha: moment().format('YYYY-MM-DD')
    },
    error: null
  },
  removeModal: {
    open: false,
    loading: false,
    id: null,
    error: null
  }
};

const libroConceptoOptions = [
  {
    key: 0,
    text: 'ACTAS ASAMBLEA',
    value: 'ACTAS ASAMBLEA'
  },
  {
    key: 1,
    text: 'ACTAS CONSEJO DE ADMINISTRACION',
    value: 'ACTAS CONSEJO DE ADMINISTRACION'
  },
  {
    key: 2,
    text: 'REGISTRO DE ASOCIADOS',
    value: 'REGISTRO DE ASOCIADOS'
  },
  {
    key: 3,
    text: 'INFORME SINDICATURA',
    value: 'INFORME SINDICATURA'
  },
  {
    key: 4,
    text: 'INFORME AUDITORIA',
    value: 'INFORME AUDITORIA'
  },
  {
    key: 5,
    text: 'DIARIO GENERAL',
    value: 'DIARIO GENERAL'
  },
  {
    key: 6,
    text: 'INVENTARIO Y BALANCES',
    value: 'INVENTARIO Y BALANCES'
  },
  {
    key: 7,
    text: 'REGISTRO DE ASISTENCIA A REUNIONES DE ASAMBLEA',
    value: 'REGISTRO DE ASISTENCIA A REUNIONES DE ASAMBLEA'
  },
  {
    key: 8,
    text: 'REGISTRO DE ASISTENCIA A REUNION DEL CONSEJO DE ADMINISTRACION',
    value: 'REGISTRO DE ASISTENCIA A REUNION DEL CONSEJO DE ADMINISTRACION'
  }
];

class CoopLibrosView extends Component {

  constructor (props) {
    super(props);

    this.state = INITIAL_STATE;
    this.LibroService = props.feathers.service('api/libros');
  }

  toggleUpsertModal = (e, libro = null) => {
    let { upsertModal } = this.state;

    if (libro) {
      this.setState(update(this.state, {
        upsertModal: {
          $merge: {
            open: !upsertModal.open,
            values: {
              id: libro.id,
              concepto: libro.concepto,
              nro: libro.nro,
              fecha: moment(libro.fecha).format('YYYY-MM-DD')
            }
          }
        }
      }));
    } else {
      this.setState(update(this.state, {
        upsertModal: {
          $merge: {
            open: !upsertModal.open
          }
        }
      }));
    }
  }

  dismissUpsert = (e) => {
    this.setState(update(this.state, {
      upsertModal: {
        $set: {
          ...INITIAL_STATE.upsertModal
        }
      }
    }));
  }

  openRemoveModal = (e, PrestamoId) => {
    this.setState(update(this.state, {
      removeModal: {
        $merge: {
          open: true,
          id: PrestamoId
        }
      }
    }));
  }

  dismissRemove = (e) => {
    this.setState({
      removeModal: INITIAL_STATE.removeModal
    });
  }

  removeRecord = (e) => {
    this.setState(update(this.state, {
      removeModal: {
        $merge: {
          loading: true,
          error: null
        }
      }
    }));

    this.LibroService.remove(this.state.removeModal.id)
      .then(response => {
        this.dismissRemove();
        this.findLibros();
      })
      .catch(error => {
        this.setState(update(this.state, {
          removeModal: {
            $merge: {
              loading: false,
              error
            }
          }
        }));
      });
  }

  inputHandler = (e, input, x) => {
    let name, value;

    if (input) {
      name = input.name;
      value = input.value;
    } else {
      name = e.target.name;
      value = e.target.value;
    }

    this.setState(update(this.state, {
      upsertModal: {
        values: {
          $merge: {
            [name]: value
          }
        }
      }
    }));
  }

  findLibros = () => {
    const {
      cooperativa: { id: CooperativaId }
    } = this.props;

    this.setState(update(this.state, {
      libros: {
        $merge: {
          loading: true,
          records: [],
          error: null
        }
      }
    }));

    this.LibroService.find({
      query: { CooperativaId }
    })
      .then(response => {
        this.setState(update(this.state, {
          libros: {
            $merge: {
              loading: false,
              records: response.records
            }
          }
        }));
      })
      .catch(error => {
        this.setState(update(this.state, {
          libros: {
            $merge: {
              loading: false,
              error
            }
          }
        }));
      });
  }

  submitUpsert = (e) => {
    e.preventDefault();

    this.setState(update(this.state, {
      upsertModal: {
        $merge: {
          loading: true
        }
      }
    }));

    let {
      cooperativa: { id: CooperativaId }
    } = this.props;
    let {
      upsertModal: { values }
    } = this.state;

    if (values.id) {
      this.LibroService.patch(values.id, {
        ...values,
        CooperativaId
      })
        .then(response => {
          this.setState(update(this.state, {
            upsertModal: {
              $merge: {
                open: false,
                loading: false
              }
            }
          }), this.findLibros);
        })
        .catch(error => {
          this.setState(update(this.state, {
            upsertModal: {
              $merge: {
                loading: false,
                error
              }
            }
          }));
        });
    } else {
      this.LibroService.create({
        ...values,
        CooperativaId
      })
        .then(response => {
          this.setState(update(this.state, {
            upsertModal: {
              $set: {
                ...INITIAL_STATE.upsertModal
              }
            }
          }), () => {
            this.findLibros();
          });
        })
        .catch(error => {
          this.setState(update(this.state, {
            upsertModal: {
              $merge: {
                loading: false,
                error
              }
            }
          }));
        });
    }
  }

  downloadXlsx = (e) => {
    let { cooperativa } = this.props;
    let { libros: { records }} = this.state;

    let wb = XLSX.utils.book_new();
    let ws = XLSX.utils.json_to_sheet(records.map(r => ({
      Concepto: r.concepto,
      Nro: r.nro,
      Fecha: moment(r.fecha).format('DD/MM/YYYY')
    })));

    XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');

    XLSX.writeFile(wb, `${snakeCase(cooperativa.nombre)}.xlsx`);
  }

  componentDidMount () {
    this.findLibros();
  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let { cooperativa } = this.props;
    let { libros, upsertModal, removeModal } = this.state;

    // onClick={e => window.open(`/csv/libros/${cooperativa.id}`)}

    return (
      <Container>
        <Segment attached="top">
          <Button icon="refresh" content="Refrescar" positive onClick={this.findLibros} />
          <Button
            disabled={libros.loading || libros.records.length === 0} icon="file text outline" content="Descargar XLSX" floated="right"
            onClick={this.downloadXlsx} />
          <Button icon="add" content="Nuevo" floated="right" primary onClick={e => this.toggleUpsertModal(e)} />
        </Segment>
        <Segment attached="bottom">
          <ReactTable
            className="-striped -highlight"
            loading={libros.loading} data={libros.records}
            defaultPageSize={10}
            columns={[
              {
                Header: '',
                width: 32,
                Cell: row => (
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      textAlign: 'center'
                    }}>
                    <Icon
                      className="edit-icon-hover" name="edit"
                      onClick={(e) => this.toggleUpsertModal(e, row.original)} />
                  </div>
                ),
                sortable: false,
                resizable: false
              },
              {
                Header: 'Concepto',
                accessor: 'concepto'
              },
              {
                Header: 'Nro',
                accessor: 'nro',
                width: 64
              },
              {
                Header: 'Fecha',
                id: 'fecha',
                accessor: d => {
                  let date = moment(d.fecha);

                  date.parseZone();
                  return date.format('DD/MM/YYYY');
                }
              },
              {
                Header: '',
                width: 32,
                Cell: row => (
                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      textAlign: 'center'
                    }}>
                    <Icon
                      color="red"
                      className="trash-icon-hover" name="trash"
                      onClick={e => this.openRemoveModal(e, row.original.id)} />
                  </div>
                ),
                sortable: false,
                resizable: false
              }
            ]}
            previousText="Anterior"
            nextText="Siguiente"
            loadingText="Cargando..."
            noDataText="Sin Registros"
            pageText="Pagina"
            ofText="de"
            rowsText="filas" />
        </Segment>
        <Modal
          dimmer="blurring" size="small"
          open={upsertModal.open} onClose={this.dismissUpsert}>
          <Header icon="edit" content="Formulario de registro" />
          <Modal.Content>
            <Form onSubmit={this.submitUpsert} loading={upsertModal.loading}>
              <Form.Group>
                <Form.Select
                  name="concepto" label="Concepto"
                  value={upsertModal.values.concepto}
                  onChange={this.inputHandler}
                  options={libroConceptoOptions}
                  width={5} />
                <Form.Input
                  name="nro" label="Nro"
                  value={upsertModal.values.nro}
                  onChange={this.inputHandler}
                  width={4} />
                <Form.Input
                  name="fecha" label="Fecha"
                  value={upsertModal.values.fecha}
                  onChange={this.inputHandler}
                  type="date" width={5} />
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button
              disabled={upsertModal.loading} basic negative icon="remove" content="Cancelar"
              onClick={this.dismissUpsert} />
            <Button
              disabled={upsertModal.loading} primary icon="plus" content="Aceptar"
              onClick={this.submitUpsert} />
          </Modal.Actions>
        </Modal>
        <Modal
          dimmer="blurring" basic size="small"
          open={removeModal.open} onClose={this.dismissRemove}>
          <Header icon="trash" content="Eliminar registro" />
          <Modal.Content>
            <p>Seguro desea eliminar este registro?</p>
            {
              removeModal.error &&
              <Message negative>
                <Message.Header>Error! {removeModal.error.message}</Message.Header>
                <p>
                  {removeModal.error.name}
                </p>
              </Message>
            }
          </Modal.Content>
          <Modal.Actions>
            <Button
              basic color="red" inverted
              disabled={removeModal.loading} onClick={this.dismissRemove}>
              <Icon name="remove" /> No
            </Button>
            <Button color="green" inverted disabled={removeModal.loading} onClick={this.removeRecord}>
              <Icon name="checkmark" /> {removeModal.loading ? 'Procesando...' : 'Si'}
            </Button>
          </Modal.Actions>
        </Modal>
      </Container>
    );
  }

}

export default connect(
  CoopLibrosView.mapStateToProps,
  CoopLibrosView.mapDispatchToProps
)(CoopLibrosView);


// WEBPACK FOOTER //
// ./client/components/pages/cooperativas/CoopLibrosView.js